module.exports = __webpack_public_path__ + "static/react-video-ae9ed1c40038b9a72a74c1fa4066614f.png";